import React, { useState, useContext } from "react";
import styled, { css } from "styled-components";
import Codes from "./Codes";
import Users from "./Users";
import Structure from "./Structure";
import { ReactComponent as Binary } from "../../assets/svg/binary.svg";
import { ReactComponent as User } from "../../assets/svg/user.svg";
import { ReactComponent as Puzzle } from "../../assets/svg/puzzle.svg";
import { ReactComponent as Search } from "../../assets/svg/search.svg";
import { ReactComponent as EnvelopeSVG } from "../../assets/svg/envelope.svg";
import { ReactComponent as IconCallerSVG } from "../../assets/svg/icon_caller.svg";
import { ReactComponent as IconCallOutbound } from "../../assets/svg/call_outbound.svg";
import { ReactComponent as IconLockDashboard } from "../../assets/svg/lock_dashboard.svg";
import { ReactComponent as WorldSVG } from "../../assets/svg/world.svg";
import { ReactComponent as AIWhatsappSVG } from "../../assets/svg/ai_whatsapp.svg";
import { UserContext } from "../../contexts/UserContext";
import ShortMessage from "../ShortMessage";
import { useHistory } from "react-router-dom";
import SearchUser from "../admin_premium/SearchUser";
import UserAPI from "../../apis/UserAPI";
import LettersPage from "../pages/LettersPage";
import { Container as MUIContainer } from '@mui/system';
import CheckoutPageSelectCourse from "./CheckoutPage/CheckoutPageSelectCourse";
import { AICaller } from "./AICaller";
import { Monitoring } from "./AICaller/Monitoring";
import { AIChat } from "./AIChat";
import { Passwords } from "../../app/pages/Admin/Passwords/Passwords.component";

const Dashboard = () => {
  let history = useHistory();

  const userContext = useContext(UserContext);
  const [state, setState] = useState("NONE");

  const allowed = ["test@test.com", "admin@admin.com", "support@support.com"];

  const is = userContext?.email && allowed.some((v) => v === userContext.email);

  if (!userContext?.email) return null;
  return (
    <Container>
      {is ? (
        <>
          <Bar>
            <Box selected={state === "CODES"} onClick={() => setState("CODES")}>
              <BoxIcon as={Binary} />
            </Box>
            <Box selected={state === "USERS"} onClick={() => setState("USERS")}>
              <BoxIcon as={User} />
            </Box>
            <Box
              selected={state === "SEARCH"}
              onClick={() => setState("SEARCH")}
            >
              <BoxIcon as={Search} />
            </Box>
            <Box selected={state === "TREE"} onClick={() => setState("TREE")}>
              <BoxIcon as={Puzzle} />
            </Box>
            <Box
              selected={state === "LETTERS"}
              onClick={() => setState("LETTERS")}
            >
              <BoxIcon as={EnvelopeSVG} />
            </Box>
            <Box
              selected={state === "PASSWORDS"}
              onClick={() => setState("PASSWORDS")}
            >
              <BoxIcon as={IconLockDashboard} />
            </Box>
            <Box
              selected={state === "CHECKOUT_PAGES"}
              onClick={() => setState("CHECKOUT_PAGES")}
            >
              <BoxIcon as={WorldSVG} />
            </Box>
            <Box
              selected={state === "AI_CHAT_BOT"}
              onClick={() => setState("AI_CHAT_BOT")}
            >
              <BoxIcon as={AIWhatsappSVG} />
            </Box>
            <Box
              selected={state === "AI_CALLER"}
              onClick={() => setState("AI_CALLER")}
            >
              <BoxIcon as={IconCallerSVG} />
            </Box>
            <Box
              selected={state === "AI_OUTBOUND_CALLS"}
              onClick={() => setState("AI_OUTBOUND_CALLS")}
            >
              <BoxIcon as={IconCallOutbound} />
            </Box>
            {/* <Box
              onClick={() => {
                UserAPI.logout();
                history.push("/");
              }}
            >
              <BoxIcon as={LogoutSVG} />
            </Box> */}
          </Bar>
          {state === "CODES" && <Codes />}
          {state === "USERS" && <Users />}
          {state === "SEARCH" && <SearchUser />}
          {state === "TREE" && <Structure />}
          {state === "LETTERS" && (
            <ContentWrapper>
              <LettersPage />
            </ContentWrapper>
          )}
          {state === "PASSWORDS" && (
              <Passwords />
          )}
          {state === "CHECKOUT_PAGES" && (
            <MUIContainer maxWidth='md'>
              <CheckoutPageSelectCourse />
            </MUIContainer>
          )}
          {state === "AI_CALLER" && (
            <div className="flex flex-row items-center justify-center p-4">
              <AICaller />
            </div>
          )}
          {state === "AI_OUTBOUND_CALLS" && (
            <div className="flex flex-row items-center justify-center p-4">
              <Monitoring />
            </div>
          )}
          {state === "AI_CHAT_BOT" && (
            <div className="flex flex-row items-center justify-center p-4">
              <AIChat />
            </div>
          )}
        </>
      ) : (
        <ShortMessage
          wrong
          message="No tienes permisos"
          onAccept={() => {
            UserAPI.logout();
            history.push("/");
          }}
        />
      )}
    </Container>
  );
};


const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
  flex-wrap: wrap;
`;

const BoxIcon = styled.div`
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  fill: #2196f3;
`;

const Box = styled.div`
  width: 100px;
  height: 100px;
  min-width: 100px;
  min-height: 100px;
  border-radius: 10px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 5px;

  ${(props) =>
    props.selected &&
    css`
      ${BoxIcon} {
        fill: white;
      }
      background-color: #2196f3;
    `}
`;

const ContentWrapper = styled.div`
  max-width: 500px;
  align-self: center;
  width: 100%;
`;

export default Dashboard;
